import ResyRewardsTerms from './ResyRewardsTerms';

export default ResyRewardsTerms;
